<template>
    <div class="search-box" :class="classes">
        <div class="search-box__input-group">
            <input type="text" v-bind="$attrs" :placeholder="placeholder" v-on="inputListeners" class="form-control search-box__input" :value="value" @input="$emit('input', $event.target.value)" />
            <span class="icon-search">
                <i class="ion-android-search" @click="$emit('search', $event.target.value)"></i>
            </span>
        </div>
    </div>
</template>
<script>
// Create search input
export default {
    name: 'InputSearch',
    inheritAttrs: false,
    props: {
        value: [String, Number],
        label: {
            type: String,
            required: false,
            default: ''
        },
        classes: {
            type: String,
            required: false
        },
        placeholder: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            value1: '',
            isFocused: false,
            message: null,
            maxLength: 1000
        };
    },
    computed: {
        listeners() {
            return {
                ...this.$listeners,
                blur: this.onBlur,
                focus: this.onFocus
            };
        },
        mergedProps() {
            return {
                ...this.$attrs,
                ...this.$props
            };
        },
        inputListeners: function () {
            let vm = this;
            return Object.assign({}, this.$listeners, {
                input: function (event) {
                    vm.$emit('input', event.target.value);
                }
            });
        }
    },
    methods: {
        changeInput(e) {
            if (e.target.value.length <= this.maxLength) {
                this.$emit('input', e.target.value);
            } else {
                e.target.value = this.value;
                this.$emit('input', this.value);
            }
        },
        onBlur() {
            this.isFocused = false;
        },
        onFocus() {
            this.isFocused = true;
        }
    }
};
</script>
<style lang="scss">
// Input Search
.search-box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    &__label {
        font-weight: 500;
        margin-right: 20px;
        min-width: 50px;
        @include Responsive(XS) {
            margin-right: 5px;
            display: none;
        }
    }
    &__input-group {
        position: relative;
        width: 100%;
        input {
            border-radius: 4px !important;
            height: 38px !important;
            font-size: 14px !important;
            padding-right: 30px;
            color: #606266 !important;
        }
        i {
            position: absolute;
            right: 10px;
            top: 2.5px;
            font-size: 24px;
            color: #000000;
            z-index: 10;
            opacity: 0.3;
        }
        .icon-search {
            position: absolute;
            background-color: #e0e0e0;
            top: 0px;
            right: 0px;
            bottom: 0px;
            z-index: 11;
            width: 38px;
            border-radius: 0px 6px 6px 0px;
        }
        input {
            &::placeholder {
                color: #c0c4cc;
            }

            :-ms-input-placeholder {
                color: #c0c4cc;
            }

            ::-ms-input-placeholder {
                color: #c0c4cc;
            }
        }
    }
}
</style>
